import { useMutation } from "@tanstack/react-query"
import AutomatedMessage from "~/api2/automated_message"

interface UseSendTestMessageProps {
  campId: string
  subject: string
  content: string
  sendTiming: number
  isBeforeCheckin: boolean
}

const useSendTestMessage = () => {
  return useMutation({
    mutationFn: ({ campId, subject, content, sendTiming, isBeforeCheckin }: UseSendTestMessageProps) =>
      AutomatedMessage.sendTestAutomatedMessage(campId, {
        subject,
        content,
        sendTiming,
        isCopyingCampEmail: false,
        isBeforeCheckin,
      }),
    onSuccess: () => {
      alert("Test email sent successfully!")
    },
    onError: (error) => {
      alert("Failed to send test email")
      console.error(error)
    },
  })
}

export default useSendTestMessage
